import type { JSX } from "react";

import { componentManager, rwc } from "@frontend/bridge/ComponentManager";

import {
  type ToolbarSectionDataProps,
  toolbarSectionDataSchema,
} from "./Toolbar.schema";
import { ToolbarSection } from "./ToolbarSection";
import { TOOLBAR_SECTION_TAG_NAME } from "./constants";

declare module "@frontend/bridge/types" {
  interface ComponentRegistryMap {
    [TOOLBAR_SECTION_TAG_NAME]: {
      props: ToolbarSectionDataProps;
      handle: undefined;
    };
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "rwc-toolbar-section": HTMLElement;
  }
}

function RWCToolbarSection(): JSX.Element {
  return (
    <ToolbarSection>
      <slot />
    </ToolbarSection>
  );
}

componentManager.register(
  rwc(TOOLBAR_SECTION_TAG_NAME, {
    component: RWCToolbarSection,
    dataSchema: toolbarSectionDataSchema,
    usesSlots: true,
  }),
);
